import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import GithubProjects from './components/GithubProjects';
import Contact from './components/Contact';
import ProjectDetails from './pages/ProjectDetails';
import AllProjects from './pages/AllProjects';
import AllGithubProjects from './pages/AllGithubProjects';
import Navbar from './components/Navbar';
import BackToTop from './components/BackToTop';
import './App.css';

let isFirstLoad = true;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (isFirstLoad) {
      // On initial hard load (F5), unconditionally force Hero view by stripping lingering hashes
      if (window.location.hash) {
        window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
      }
      
      window.scrollTo(0, 0);
      setTimeout(() => window.scrollTo(0, 0), 100);
      
      isFirstLoad = false;
    } else {
      // On soft React navigations, zero out the scroll ONLY if not actively using a HashLink
      if (!window.location.hash) {
        window.scrollTo(0, 0);
      }
    }
  }, [pathname]);

  return null;
};

const Home = () => (
  <main>
    <Hero />
    <About />
    <Experience />
    <Skills />
    <Projects />
    <GithubProjects />
    <Contact />
  </main>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <div className="bg-glow"></div>
        <div className="bg-glow"></div>
        <Navbar />
        <BackToTop />
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<AllProjects />} />
          <Route path="/github-projects" element={<AllGithubProjects />} />
          <Route path="/project/:id" element={<ProjectDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
